import {atomWithStorage} from 'jotai/utils';

/**
 * Per-browser flag: which home banners the viewer has dismissed. Calendar-driven
 * banners are keyed by banner `type`, managed ones by banner ID.
 */
export type BannerDismissedStore = Record<string, boolean>;

export const bannerDismissedAtom = atomWithStorage<BannerDismissedStore>(
  'home:bannerDismissed',
  {},
  undefined,
  {getOnInit: true}
);
